export const titleMixin = {
  watch: {
    title: {
      immediate: true,
      handler() {
        document.title = this.title;
      }
    }
  }
}